<ion-header>
  <ion-toolbar>
    <ion-title>Edit Can</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="closeModal()" data-testid="edit-can-close">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding" [formGroup]="form">
  <!-- <ion-item lines="full">
  <ion-thumbnail slot="start">
    <img src="/assets/icons/flat/beer/cans/beer-can.svg" />
  </ion-thumbnail>
  {{ item()?.name }}
</ion-item> -->
<ion-card class="ion-no-margin ion-no-padding">
  <ion-card-content class="ion-no-padding">
    <ion-item lines="full">
      <ion-input
        #count
        label="Cans"
        labelPlacement="floating"
        type="number"
        inputmode="numeric"
        required="required"
        formControlName="count"
        placeholder="cans"
      ></ion-input>
      <ion-note slot="error">You need to add at least one can</ion-note>
    </ion-item>
    <ion-item lines="full">
      <ion-input
        label="Unique ID / Barcode"
        labelPlacement="floating"
        formControlName="uniqueId"
        placeholder="Unique identifier (for scanning)"
        type="text"
      ></ion-input>
      <app-barcode-scanner slot="end"
        (barcodeScanned)="handleBarcodeScanned($event)"
      [displayResult]="false" [addingInventory]="false" ></app-barcode-scanner>
    </ion-item>
    <ion-item lines="none">
      <ion-select
        label="Location"
        labelPlacement="floating"
        formControlName="location"
        interface="popover"
        >
        <ion-select-option value="">Choose location</ion-select-option>
        @for (location of locations(); track location) {
          <ion-select-option
            [value]="location.id"
            >
            {{ location.name }}
          </ion-select-option>
        }
      </ion-select>
    </ion-item>
  </ion-card-content>
</ion-card>

<div>
  <ion-text color="medium">
    <h6>Dates</h6>
  </ion-text>
  <ion-card class="ion-no-margin ion-no-padding">
    <ion-card-content class="ion-no-padding">
      <ion-item lines="full">
        <ion-label>Canned Date</ion-label>
        @if (filledDate) {
          <ion-datetime-button
            slot="end"
            datetime="itemTapDate"
          ></ion-datetime-button>
        }
        @if (!filledDate) {
          <ion-button (click)="setDefaultFilledDate()" slot="end" fill="clear" shape="round" color="success" size="default">
            <ion-icon
              size="small"
              slot="icon-only"
              name="add-circle-outline"
            ></ion-icon>
          </ion-button>
        }
        @if (filledDate) {
          <ion-button (click)="deleteFilledDate()" slot="end" fill="clear" shape="round" color="danger" size="default">
            <ion-icon
              size="small"
              slot="icon-only"
              name="trash-outline"
            ></ion-icon>
          </ion-button>
        }
        <ion-modal [keepContentsMounted]="true">
          <ng-template>
            @if (filledDate) {
              <ion-datetime
                presentation="date"
                [value]="filledDate"
                size="cover"
                id="itemTapDate"
                (ionChange)="setFilledDate($event)"
                showDefaultButtons="true"
                >
                <span slot="title">item Date</span>
              </ion-datetime>
            }
          </ng-template>
        </ion-modal>
      </ion-item>
      <ion-item lines="none">
        <ion-label>Best Before Date</ion-label>
        @if (bestBeforeDate) {
          <ion-datetime-button
            slot="end"
            datetime="itemBestBeforeDate"
          ></ion-datetime-button>
        }
        @if (!bestBeforeDate) {
          <ion-button (click)="setDefaultBestBeforeDate()" slot="end" fill="clear" shape="round" color="success" size="default">
            <ion-icon
              size="small"
              slot="icon-only"
              name="add-circle-outline"
            ></ion-icon>
          </ion-button>
        }
        @if (bestBeforeDate) {
          <ion-button (click)="deleteBestBeforeDate()" slot="end" fill="clear" shape="round" color="danger" size="default">
            <ion-icon
              size="small"
              slot="icon-only"
              name="trash-outline"
            ></ion-icon>
          </ion-button>
        }
        <ion-modal [keepContentsMounted]="true">
          <ng-template>
            @if (bestBeforeDate) {
              <ion-datetime
                max="2100-12-31"
                presentation="date"
                [value]="bestBeforeDate"
                size="cover"
                id="itemBestBeforeDate"
                (ionChange)="setBestBeforeDate($event)"
                showDefaultButtons="true"
                >
                <span slot="title">Best Before Date</span>
              </ion-datetime>
            }
          </ng-template>
        </ion-modal>
      </ion-item>
    </ion-card-content>
  </ion-card>
</div>

<div>
  <ion-text color="medium">
    <h6>Notification</h6>
  </ion-text>
  <ion-card class="ion-no-margin ion-no-padding">
    <ion-card-content class="ion-no-padding">
      <ion-item lines="full">
        <ion-label>Date</ion-label>
        @if (notificationDate) {
          <ion-datetime-button
            slot="end"
            datetime="itemCanNotificationDate"
          ></ion-datetime-button>
        }
        @if (!notificationDate) {
          <ion-button (click)="setDefaultNotificationDate()" slot="end" fill="clear" shape="round" color="success" size="default">
            <ion-icon
              size="small"
              slot="icon-only"
              name="add-circle-outline"
            ></ion-icon>
          </ion-button>
        }
        @if (notificationDate) {
          <ion-button (click)="deleteNotificationDate()" slot="end" fill="clear" shape="round" color="danger" size="default">
            <ion-icon
              size="small"
              slot="icon-only"
              name="trash-outline"
            ></ion-icon>
          </ion-button>
        }
        <ion-modal [keepContentsMounted]="true">
          <ng-template>
            @if (notificationDate) {
              <ion-datetime
                max="2100-12-31"
                presentation="date"
                [value]="notificationDate"
                size="cover"
                id="itemCanNotificationDate"
                (ionChange)="setNotificationDate($event)"
                showDefaultButtons="true"
                >
                <span slot="title">Notification Date</span>
              </ion-datetime>
            }
          </ng-template>
        </ion-modal>
      </ion-item>
      <ion-item lines="none">
        <ion-input
          label="Message"
          labelPlacement="floating"
          type="text"
          formControlName="notificationMessage"
          placeholder="Message text"
        ></ion-input>
      </ion-item>
    </ion-card-content>
  </ion-card>
</div>
</ion-content>

<ion-footer>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button color="success" fill="solid" (click)="dismiss()">
        Save
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>